export const loginHeroTitle = {
  display: 'flex',
  alignItems: 'center',
  mt: 6,
  fontWeight: 600,
  fontSize: {
    xs: '2.6rem',
  },
  '@media (max-width: 445px)': {
    fontSize: '1.9rem',
    mt: 2,
  },
  '@media (max-width: 345px)': {
    fontSize: '1.8rem',
  },
};

export const loginHeroDescription = {
  display: 'flex',
  alignItems: 'center',
  mt: 2,
  color: 'rgba(0, 0, 0, .7)',
  fontWeight: 400,
  fontSize: {
    xs: '1.25rem',
  },
  letterSpacing: '2%',
};
